import React, { useState } from 'react';
import { serverFilename } from './ReportPlanCard';

/** Lane 1409 (the chat workbench): the files an answer produced, as download
 *  chips under the answer. Each chip fetches through the authenticated route
 *  (the server re-checks the company and the file's digest) and saves the
 *  blob; the browser never holds a storage link. The chip text comes from the
 *  server's record (name, size, check status), never from the model. */

function humanSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function checkLine(file) {
  if (!file) return '';
  if (file.check_line) return file.check_line;
  return 'Not checked by Wingman.';
}

export default function ChatFileChips({ files, authFetch, note }) {
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(null);
  const list = Array.isArray(files) ? files : [];
  if (list.length === 0 && !note) return null;

  const download = async (file) => {
    setNotice('');
    setBusy(file.artifact_id);
    try {
      const response = await authFetch(`/api/chat/files/${file.artifact_id}/download`);
      if (!response.ok) {
        setNotice('The file could not be downloaded right now.');
        return;
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = serverFilename(response) || file.filename || 'file.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setNotice('The file could not be downloaded right now.');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="hm-filechips" data-testid="hm-file-chips" role="group" aria-label="Files from this answer">
      {list.map((file) => (
        <div key={file.artifact_id} className="hm-filechip">
          <button type="button" className="hm-rptoffer-btn"
            disabled={busy === file.artifact_id}
            onClick={() => download(file)}
            data-testid="hm-file-chip-download">
            Download {file.filename} ({humanSize(file.byte_size)})
          </button>
          <span className={file.check_status === 'failed'
            ? 'hm-filechip-check hm-filechip-check-failed' : 'hm-filechip-check'}>
            {checkLine(file)}
          </span>
        </div>
      ))}
      {note ? <div className="hm-filechip-note">{note}</div> : null}
      {notice ? <div className="hm-filechip-notice" role="status">{notice}</div> : null}
    </div>
  );
}
